// Types
type OnMessageCallback = (event: MessageEvent) => void;

type WindowName = string;
type ServiceProps = {
    url: string;
    target: '_self' | '_blank' | '_parent' | '_top' | WindowName;
    options: string;
}

const enum WindowEvents {
    CLOSE_WINDOW = 'CLOSE_WINDOW',
}

class ExternalWindow {
    private onMessageCallback: OnMessageCallback;

    private windowRef: Window;

    public constructor({
        url,
        target = '_blank',
        options = '',
    }: ServiceProps) {
        this.windowRef = window.open(url, target, options);

        this.windowRef.onbeforeunload = () => {
            this.disposeListeners();
        };
    }

    public close(): void {
        if (!this.isActiveWindow) {
            return;
        }

        this.windowRef.close();
        this.disposeListeners();
    }

    public onMessage(callback: OnMessageCallback): void {
        this.onMessageCallback = (event) => {
            callback(event);
        };

        window.addEventListener('message', this.onMessageCallback);
    }

    private get isActiveWindow() {
        return this.windowRef && !this.windowRef.closed;
    }

    private disposeListeners() {
        window.removeEventListener('message', this.onMessageCallback);
    }
}

export {
    WindowEvents,
    ExternalWindow,
};